package com.checkin.host.ui.legal

import androidx.compose.runtime.Composable
import com.checkin.host.theme.AppColors
import com.checkin.host.ui.auth.AuthRoute
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun LegalAcceptanceCheckboxes(
    returnRoute: AuthRoute,
    acceptTerms: Boolean,
    acceptPrivacy: Boolean,
    onAcceptTermsChange: (Boolean) -> Unit,
    onAcceptPrivacyChange: (Boolean) -> Unit,
    onOpenLegal: (AuthRoute) -> Unit,
) {
    Div({ style { marginBottom(16.px) } }) {
        LegalCheckboxRow(
            checked = acceptTerms,
            onChange = onAcceptTermsChange,
        ) {
            Text("J'accepte les ")
            LegalLink("conditions générales d'utilisation") {
                onOpenLegal(AuthRoute.LegalTerms(returnRoute))
            }
        }

        Div({ style { marginTop(10.px) } }) {
            LegalCheckboxRow(
                checked = acceptPrivacy,
                onChange = onAcceptPrivacyChange,
            ) {
                Text("J'accepte la ")
                LegalLink("politique de confidentialité") {
                    onOpenLegal(AuthRoute.LegalPrivacy(returnRoute))
                }
            }
        }

        P({
            style {
                marginTop(12.px)
                fontSize(12.px)
                color(AppColors.muted)
                lineHeight("1.5")
            }
        }) {
            Text("Le traitement des données de vos invités est régi par le ")
            LegalLink("contrat de sous-traitance (DPA)") {
                onOpenLegal(AuthRoute.LegalDpa(returnRoute))
            }
            Text(". En cochant les cases ci-dessus et en utilisant la vérification invité, vous l'acceptez.")
        }
    }
}

@Composable
private fun LegalCheckboxRow(
    checked: Boolean,
    onChange: (Boolean) -> Unit,
    label: @Composable () -> Unit,
) {
    Div({
        style {
            display(DisplayStyle.Flex)
            alignItems(AlignItems.FlexStart)
            gap(10.px)
            fontSize(13.px)
            color(AppColors.muted)
            cursor("pointer")
            lineHeight("1.5")
        }
    }) {
        Input(type = org.jetbrains.compose.web.attributes.InputType.Checkbox) {
            checked(checked)
            onInput { onChange((it.target as org.w3c.dom.HTMLInputElement).checked) }
            style {
                marginTop(3.px)
                width(16.px)
                height(16.px)
                cursor("pointer")
            }
        }
        Span { label() }
    }
}

@Composable
private fun LegalLink(text: String, onClick: () -> Unit) {
    Span({
        style {
            color(AppColors.primary)
            cursor("pointer")
            property("text-decoration", "underline")
        }
        onClick { event ->
            event.stopPropagation()
            onClick()
        }
    }) {
        Text(text)
    }
}

@Composable
fun AuthLegalFooter(onOpenLegal: (AuthRoute) -> Unit) {
    P({
        style {
            marginTop(20.px)
            textAlign("center")
            fontSize(12.px)
            color(AppColors.muted)
            lineHeight("1.6")
        }
    }) {
        Span({
            style { color(AppColors.primary); cursor("pointer") }
            onClick { onOpenLegal(AuthRoute.LegalPrivacy(AuthRoute.Login)) }
        }) { Text("Confidentialité") }
        Text(" · ")
        Span({
            style { color(AppColors.primary); cursor("pointer") }
            onClick { onOpenLegal(AuthRoute.LegalTerms(AuthRoute.Login)) }
        }) { Text("CGU") }
        Text(" · ")
        Span({
            style { color(AppColors.primary); cursor("pointer") }
            onClick { onOpenLegal(AuthRoute.LegalDpa(AuthRoute.Login)) }
        }) { Text("DPA") }
    }
}
